import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { validity_date_v2 } from 'src/app/core/Constants/static';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { AllerrgyCodeService } from '../../../services/allerrgyCode.service';
import { AllergyCodeList } from 'src/app/core/Models/interfaces/master-management/allergyCodeList';
import { permission } from 'src/app/core/Constants/permissions';

@Component({
  selector: 'app-allergy-code-management-list',
  templateUrl: './allergy-code-management-list.component.html',
  styleUrls: ['./allergy-code-management-list.component.css']
})
export class AllergyCodeManagementListComponent implements OnInit {

  @ViewChildren('focusedElement') focusedElement!: QueryList<ElementRef>;

  private sortParams!: string;
  private page_limit!: number;
  
  public permissions=permission;
  public allergyfilterForm!: FormGroup;
  public page_no: number = 1;
  public totalCount!: number;
  public isAddpage: boolean = false;
  public isEdit: boolean = false;
  public feild_startDate = validity_date_v2;
  public columnSort: Record<string, { sortType: string, clicked: boolean }> = {
    activeFrom: {
      sortType: 'ascending',
      clicked: true
    },
    allergyVersion: {
      sortType: 'ascending',
      clicked: true
    },
    allergyVersionDesc: {
      sortType: 'ascending',
      clicked: true
    },
  };
  public selectedVersion!: AllergyCodeList;
  public allergyCodeList: AllergyCodeList[] = []

  constructor(
    private toasterandLoader: ToasterService,
    private userService: UserService,
    private router: Router,
    private allerrgyCodeService: AllerrgyCodeService
  ) { }


  private createfilterForm(): void {
    this.allergyfilterForm = new FormGroup({
      version: new FormControl(null),
      validity: new FormControl(null),
      inUse: new FormControl(null)
    });
  }


  private applyFilter(): void {
    // if (this.checkPermission('getDrugList')) {
    this.toasterandLoader.isLoaderEnable(true);
    const validity = this.allergyfilterForm?.value?.validity;
    const valStart = validity?.substring(0, validity.indexOf(' '));
    const parts: string[] = validity?.split(' ');
    const valEnd = parts?.pop();
    const validityStart = valStart?.split("/").reverse().join("-");
    const validityEndDate = valEnd?.split("/").reverse().join("-");
    const payLoad = {
      per_page: this.page_limit,
      page: this.page_no,
      sort: this.sortParams,
      allergyVersion: this.allergyfilterForm?.value?.version ? this.allergyfilterForm?.value?.version : '',
      activeFrom: validityStart ? validityStart : '',
      expiredOn: validityEndDate ? validityEndDate : '',
      isActive: this.allergyfilterForm?.controls?.['inUse']?.value ? 1 : '',
    }
    this.allerrgyCodeService.getAllergyCodeList(payLoad).subscribe({
      next: (response) => {
        if (response) {
          this.allergyCodeList = response?.data?.data;
          this.totalCount = response?.data?.total;
          // if (!this.diagnosisList?.length) this.showNavigation = true;
          this.toasterandLoader.isLoaderEnable(false);
        }
      },
      error: (error) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error.message
        });
        this.toasterandLoader.isLoaderEnable(false);
      },
    })
    // }
  }

  private isScrollIntoViewNeeded(): void {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  private navigateToView(item: AllergyCodeList): void {
    let url = this.router.url;
    if (url.includes('/master-management/allergy-management')) {
      this.router.navigate(['master-management', 'allergy-detail-view', item.allergyVersionId]);
    }
  }





  public ngOnInit(): void {
    this.createfilterForm();
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }


  public sortColumn(colName: string): void {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        const element = this.columnSort[key];
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.applyFilter();
        } else {
          this.columnSort[key].sortType = 'ascending';
        }
      }
    }
  }


  public addNewAlleryCode(): void {
    this.isAddpage = true;
    this.isEdit = false;
  }

  public currentPageDetail(event: Pagination): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.applyFilter();
  }

  public closeAddEdit(event: boolean) {
    this.isAddpage = false;
    this.filterOnClick();
  }

  public filterOnClick(): void {
    this.page_no = 1;
    this.applyFilter();
  }
  public resetFilter(): void {
    this.allergyfilterForm.reset();
    this.page_limit = 10;
    this.page_no = 1;
    this.totalCount = 1;
    // this.showNavigation = false;
    this.applyFilter();
  }

  public ShowDetailView(version: AllergyCodeList): void {
    this.navigateToView(version)
  }

  public showEdit(item: AllergyCodeList): void {
    this.isAddpage = true;
    this.isEdit = true;
    this.selectedVersion = item;
  }


}
